/** . */
export const CLASS_MARKER = 46;
/** # */
export const ID_MARKER = 35;
/** space */
export const PAIR_SEPARATOR = 32;
/** = */
export const KEY_SEPARATOR = 61;
/** " */
export const QUOTE_MARKER = 34;
